import React from 'react';
import { useParams } from 'react-router';
import { editFaq } from '../../../../Apis/FAQsApi';
import Form from './Form';

export default function EditFaq() {
    const { id } = useParams();
    // onsubmit
    const onSubmit = async (e, data) => {
        e.preventDefault();
        //to send request
        return await editFaq(id , {...data , "_method" : "patch"}).then(res => {
            return "done";          
        }).catch(err => {
            console.log(err.response);
            return err.response.data.errors;
        })
    };
    return (
        <Form onSubmit={onSubmit}/>
    )
}
